import { readFileSync } from "node:fs";
import { relative } from "node:path";
import { extractFrontmatter } from "../markdown.js";
import type { ParsedFile, ScaffoldFrontmatter } from "../types.js";

/** Read a scaffold file and extract its YAML frontmatter */
export function parseFrontmatter(
  filePath: string
): ScaffoldFrontmatter | null {
  try {
    const content = readFileSync(filePath, "utf-8");
    return extractFrontmatter(content);
  } catch {
    return null;
  }
}

/**
 * Read a scaffold file once into a ParsedFile (content, lines, frontmatter).
 * Returns null if the file cannot be read.
 */
export function parseScaffoldFile(
  filePath: string,
  projectRoot: string
): ParsedFile | null {
  let content: string;
  try {
    content = readFileSync(filePath, "utf-8");
  } catch {
    return null;
  }
  return {
    path: filePath,
    source: relative(projectRoot, filePath),
    content,
    lines: content.split("\n"),
    frontmatter: extractFrontmatter(content),
  };
}
